import { Language } from 'types/language'
import { CmsProduct, CmsReferralAction } from 'types/cms/collection-types'
import { Product } from '@boltenergy-be/shared'

export type GetProductsPayload = {
  language: Language
}

export type GetProductsResponse = {
  [key in Product]: CmsProduct
}

export type GetPlentyPaymentStatusResponse = {
  paymentMethod: PlentySfPaymentMethod
  paymentStatus: PlentySfPaymentStatus
}

export type GetActiveReferralActionResponse = {
  action: CmsReferralAction | null
}

export type GetActiveReferralActionPayload = {
  locale: Language
  replaceNameBy?: string
}

export type GetPlentyEnvCheckResponse = {
  exists: boolean
  isInvestor: boolean
}

export enum PlentySfPaymentMethod {
  BANK_TRANSFER = 'Bank Transfer',
  PAYMENT_ENGINE = 'Payment Engine'
}

export enum PlentySfPaymentStatus {
  CANCELED = 'Canceled',
  EXPIRED = 'Expired',
  FAILED = 'Failed',
  OPEN = 'Open',
  PAID = 'Paid'
}
